// No built in support for knowing start day of week based on locale
// As of June 2023 it is a proposal in stage 3, see: https://tc39.es/proposal-intl-locale-info/
// Map all locales that does not start with Monday, 1-7 is MON-SUN
const firstDayOfWeekMap: Record<string, number> = {
  'en-US': 7,
  'en-CA': 7,
  'fr-CA': 7,
  'ja-JP': 7,
  'en-JP': 7,
  'en-IN': 7,
  'ko-KR': 7,
  'en-KR': 7,
};

/**
 * Get Days Of Week
 *
 * Get a list of the week days for a locale. Translated and starting on the
 * correct day of the week.
 *
 * @param locale Eg 'en-US' or 'se-SV'
 * @param weekday 'long' | 'short' | 'narrow'
 * @returns A list with the days of the week and their week day number
 */
export const getDaysOfWeek = (
  locale: string,
  weekday: 'long' | 'short' | 'narrow' = 'long'
): Array<{
  day: number;
  name: string;
}> => {
  const formatWeekDay = new Intl.DateTimeFormat(locale, { weekday }).format;
  const firstDayOfWeek = firstDayOfWeekMap[locale] ?? 1; // Monday (1) is the default

  // 1st May 2023 is a Monday (May is monthIndex 4)
  return Array.from({ length: 7 }, (_, index) => {
    const day = ((index + firstDayOfWeek - 1) % 7) + 1;
    return {
      day,
      name: formatWeekDay(new Date(2023, 4, day)),
    };
  });
};
